"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Optional': 'Optional'
        }
    },
    'cs': {
        'translation': {
            'Optional': 'Volitelný'
        }
    },
    'zh': {
        'translation': {
            'Optional': '可选的'
        }
    }
};
